module.exports = __webpack_public_path__ + "static/nav-bg-e6d8d4fccf20ccef500aff54112b2847.png";